{
  "title": "Audit Events",
  "description": "A record of the changes made in your account: what happened, who or what did it, and what it affected.",
  "noDataTitle": "No Audit Events Yet",
  "noDataMessage": "Audit events will appear here as changes are made in your account.",
  "noFilteredDataMessage": "No audit events match the selected filters.",
  "notFoundTitle": "Audit Event Not Found",
  "notFoundMessage": "This audit event does not exist, or it could not be fetched.",
  "fetchFailed": "An error occurred while trying to fetch audit events.",
  "actorType": {
    "user": "User",
    "service": "Service",
    "system": "System"
  },
  "filter": {
    "event": "Event Name",
    "eventPlaceholder": "component.resource.action",
    "entityType": "Entity Type",
    "entityId": "Entity Id",
    "application": "Application",
    "correlationId": "Correlation Id",
    "dateRange": "Date Range",
    "multipleValues": "Separate multiple values with commas, up to 20.",
    "entityIdHelp": "Needs an entity type. Separate multiple values with commas, up to 20.",
    "invalidEvent": "An event name has three dot-separated parts, like auth.accesskey.update.",
    "tooManyValues": "A filter takes at most 20 comma-separated values.",
    "entityIdNeedsType": "Filtering by entity id needs an entity type.",
    "invalidRange": "The date range must start before it ends.",
    "correlationNeedsRange": "Searching by correlation id needs a date range.",
    "correlationRangeTooWide": "Searching by correlation id needs a date range of 24 hours or less."
  },
  "table": {
    "time": "Time",
    "event": "Event",
    "actor": "Actor",
    "entity": "Entity",
    "view": "View"
  },
  "change": {
    "field": "Field",
    "previous": "Previous",
    "current": "Current",
    "kind": {
      "created": "Created",
      "updated": "Updated",
      "removed": "Removed"
    }
  },
  "detail": {
    "actor": "Actor",
    "actorType": "Type",
    "actorName": "Name",
    "actorEmail": "Email",
    "actorId": "Actor Id",
    "actorAccount": "Account",
    "entity": "Entity",
    "entityType": "Type",
    "entityId": "Entity Id",
    "viewEntity": "View entity details",
    "changes": "Changes",
    "noChanges": "This event recorded no field changes.",
    "context": "Additional Context",
    "rawEvent": "Raw Event",
    "event": "Event",
    "occurred": "Occurred",
    "received": "Received",
    "eventName": "Event Name",
    "eventId": "Event Id",
    "correlationId": "Correlation Id",
    "source": "Source",
    "application": "Application",
    "version": "Version"
  }
}
